import React, { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmDialog = (props) => {
  const { onClose, title, text, open, onConfirm, ...other } = props;


  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onConfirm();
  };


  return (
    <Dialog
      TransitionComponent={Transition}
      onClose={handleCancel}
      maxWidth="md"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      {...other}
    >
      <DialogTitle id="confirmation-dialog-title">
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
          {title}
        </span>
      </DialogTitle>
      <DialogContent dividers>
        {text}
      </DialogContent>
      <DialogActions>
        <button type="submit" className="btn btn-primary btn-block btn-ripple"
          onClick={handleOk}>تایید
        </button>
        <button type="submit" className="btn btn-default btn-ripple"
          onClick={handleCancel}>لغو
        </button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog;